import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'

@observer
class Tabs extends PureComponent {
    renderTabs = () => {
        const { dashboardWizardStore } = this.props
        const { currentStage, goToStage, stages } = dashboardWizardStore
        return stages
            .map((s, i) => {
                if (!s.showInTabs) return null
                return (
                    <div
                        className={`tab ${currentStage >= i ? 'active' : ''}`}
                        onClick={() => goToStage(i)}
                        role="button"
                        onKeyDown={() => goToStage(i)}
                        tabIndex={0}
                    >
                        <span className="stageNum">{s.tabNumber}</span>
                        <span className="stageName">{s.label}</span>
                    </div>
                )
            })
    }

    render() {
        return (
            <div className="tabs">
                {this.renderTabs()}
            </div>
        )
    }
}

export default Tabs
